<template>
    <aside
        class="magico-navbar js-navbar-vertical-aside navbar navbar-vertical-aside navbar-vertical navbar-vertical-fixed navbar-expand-xl navbar-bordered bg-white">
        <div class="navbar-vertical-container">
            <div class="navbar-vertical-footer-offset">
                <!-- Navbar Vertical Toggle -->
                <button ref="btnToogler" type="button"
                    class="js-navbar-vertical-aside-toggle-invoker navbar-aside-toggler">
                    <i class="bi-arrow-bar-left navbar-toggler-short-align"
                        data-bs-template='<div class="tooltip d-none d-md-block" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
                        data-bs-toggle="tooltip" data-bs-placement="right" title="Collapse"></i>
                    <i class="bi-arrow-bar-right navbar-toggler-full-align"
                        data-bs-template='<div class="tooltip d-none d-md-block" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
                        data-bs-toggle="tooltip" data-bs-placement="right" title="Expand"></i>
                </button>
                <!-- End Navbar Vertical Toggle -->

                <!-- Content -->
                <div class="navbar-vertical-content">
                    <div id="navbarVerticalMenu" class="nav nav-pills nav-vertical card-navbar-nav">
                        <div class="nav-item">
                            <router-link to="/" class="nav-link " :class="{ active: $route.path == '/' }"
                                data-placement="left">
                                <i class="bi-grid nav-icon"></i>
                                <span class="nav-link-title">Dashboard</span>
                            </router-link>
                        </div>

                        <span class="dropdown-header mt-4">Zarządzanie SMS</span>
                        <small class="bi-three-dots nav-subtitle-replacer"></small>

                        <div class="nav-item">
                            <router-link to="/client" class="nav-link "
                                :class="{ active: $route.meta.menu == 'client' }" data-placement="left">
                                <i class="bi-people nav-icon"></i>
                                <span class="nav-link-title">Klienci API</span>
                            </router-link>
                        </div>

                        <div class="nav-item">
                            <router-link to="/sms" class="nav-link "
                                :class="{ active: $route.meta.menu == 'sms' }" data-placement="left">
                                <i class="bi-chat-dots nav-icon"></i>
                                <span class="nav-link-title">Wysłane SMS</span>
                            </router-link>
                        </div>

                        <div class="nav-item" v-if="isAdmin">
                            <router-link to="/nadpis" class="nav-link "
                                :class="{ active: $route.meta.menu == 'nadpis' }" data-placement="left">
                                <i class="bi-chat-quote nav-icon"></i>
                                <span class="nav-link-title">Nadpis (Sender ID)</span>
                            </router-link>
                        </div>

                        <span class="dropdown-header mt-4">System</span>
                        <small class="bi-three-dots nav-subtitle-replacer"></small>

                        <div class="nav-item">
                            <router-link to="/settings" class="nav-link "
                                :class="{ active: $route.meta.menu == 'settings' }" data-placement="left">
                                <i class="bi-gear nav-icon"></i>
                                <span class="nav-link-title">Ustawienia</span>
                            </router-link>
                        </div>

                        <div class="nav-item">
                            <a href="#" class="nav-link" @click.prevent="logout">
                                <i class="bi-box-arrow-right nav-icon"></i>
                                <span class="nav-link-title">Wyloguj</span>
                            </a>
                        </div>
                    </div>
                </div>
                <!-- End Content -->

                <!-- Footer -->
                <div class="navbar-vertical-footer">
                    <ul class="navbar-vertical-footer-list">
                        <li class="navbar-vertical-footer-list-item">
                            <color-switcher></color-switcher>
                        </li>
                    </ul>
                </div>
                <!-- End Footer -->
            </div>
        </div>
    </aside>
</template>

<script>
import HSSideNav from 'Front-Dashboard/src/assets/vendor/hs-navbar-vertical-aside/dist/hs-navbar-vertical-aside.js'
import ColorSwitcher from './ColorSwitcher.vue'

export default {
    name: 'Sidebar',
    components: { ColorSwitcher },
    computed: {
        isAdmin: function () {
            return ['owner', 'manager'].includes(this.$store.getters['app/role'])
        },
    },
    methods: {
        logout() {
            this.$root.logout();
        }
    },
    mounted() {
        let vm = this;
        if (vm.$refs.btnToogler) {
            setTimeout(function () {
                vm.$refs.btnToogler.style.opacity = 1;
            }, 100);
        }
        // Initialize Sidebar
        const sidebar = new HSSideNav('.js-navbar-vertical-aside').init();
    }
}
</script>

<style scoped>
.nav-link.active {
    background-color: rgba(55, 125, 255, 0.1);
    color: #377dff;
    font-weight: 600;
}

.nav-icon {
    font-size: 1.1rem;
}

.dropdown-header {
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.05rem;
    color: #8c98a4;
    padding-left: 1rem;
}
</style>